var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoBenefice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.009,
    height: 11.947,
    viewBox: "0 0 13.009 11.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2838",
    "data-name": "Groupe 2838",
    transform: "translate(0 0.312)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 3.914,
    height: 4.118,
    rx: 1,
    transform: "translate(0 7.517)",
    fill: "#17d395"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    width: 3.914,
    height: 6.432,
    rx: 1,
    transform: "translate(4.547 5.203)",
    fill: "#17d395"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 3.914,
    height: 11.635,
    rx: 1,
    transform: "translate(9.094)",
    fill: "#17d395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1023",
    "data-name": "Trac\\xE9 1023",
    d: "M1427.7-2259.554v-2.245h-2.245",
    transform: "translate(-1420.679 2262.497)",
    fill: "#17d395",
    stroke: "#16d395",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_104",
    "data-name": "Ligne 104",
    x1: 4.454,
    y2: 4.454,
    transform: "translate(2.518 0.749)",
    fill: "none",
    stroke: "#16d395",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoBenefice);
export default __webpack_public_path__ + "static/media/picto-benefice.3b26a46a4304118bf675a4885e5c8923.svg";
export { ForwardRef as ReactComponent };